import React, { useEffect, useState } from "react";
import { Select, Table } from "antd";
import PropTypes from "prop-types";
import { API_BASE_URL } from "../Config/Config";
import Swal from "sweetalert2";
const Devicesmodel = ({ record }) => {
  console.log(record, "record");
  const userData = JSON.parse(
    sessionStorage.getItem("HealthCheckuser") || "[]"
  );

  const [deviceLoading, setDeviceLoading] = useState(false);
  const [deviceData, setDeviceData] = useState([]);


  const [isEdit, setIsEdit] = useState(false);

  const resetDeviceForm = () => {
    setDeviceForm({
      Id: 0,
      LocationId: null,
      LocationName: "",
      SerialNo: "",
      MachineId: "",
      DeviceName: "",
      DeviceTypeId: null,
      DeviceModel: "",
      ServerPort: "",
      IsSpecial: false,
    });

    setIsEdit(false);
  };

  const [deviceForm, setDeviceForm] = useState({
    Id: 0,
    LocationId: null,
    LocationName: "",
    SerialNo: "",
    MachineId: "",
    DeviceName: "",
    DeviceTypeId: null,
    DeviceModel: "",
    ServerPort: "",
    IsSpecial: false,
  });
  const columns = [
    {
      title: "S.No",
      dataIndex: "SerialNo",
      key: "SerialNo",
      render: (text) => (
        <span title={text}>
          {text?.length > 5 ? `${text.substring(0, 5)}...` : text}
        </span>
      ),
    },
    {
      title: "Mac.ID",
      dataIndex: "MachineId",
      key: "MachineId",
    },
    {
      title: "Location",
      dataIndex: "LocationName",
      key: "LocationName",
      render: (text) => (
        <span title={text}>
          {text?.length > 5 ? `${text.substring(0, 5)}...` : text}
        </span>
      ),
    },
    {
      title: "DevName",
      dataIndex: "DeviceName",
      key: "DeviceName",
      render: (text) => (
        <span title={text}>
          {text?.length > 6 ? `${text.substring(0, 6)}...` : text}
        </span>
      ),
    },

    {
      title: "DevType",
      dataIndex: "DeviceType",
      key: "DeviceType",
    },
    {
      title: "DevModel",
      dataIndex: "DeviceModel",
      key: "DeviceModel",
    },
    {
      title: "Server Port",
      dataIndex: "ServerPort",
      key: "ServerPort",
    },
    {
      title: "Status",
      dataIndex: "IsActive",
      key: "IsActive",
      render: (text) => (
        <div className="d-flex align-items-center gap-2">
          <span
            style={{
              width: "15px",
              height: "15px",
              borderRadius: "50%",
              display: "inline-block",
              backgroundColor: text === true ? "#22c55e" : "#ef4444",
            }}
          />
        </div>
      ),
    },
    {
      title: "Actions",
      key: "actions",
      render: (_, Devicerecord) => (
        <div className="d-flex align-items-center gap-2">
          <button
            type="button"
            className="btn btn-sm btn-light border"
            onClick={() => handleEditDevice(Devicerecord)}
          >
            <i className="ti ti-edit" />
          </button>

          {Devicerecord?.IsActive && (
          <button
            type="button"
            className="btn btn-sm btn-light border"
          onClick={() => deleteDevice(Devicerecord)}
          >
            <i className="ti ti-trash text-danger" />
          </button>
            )}
        </div>
      ),
    },
  ];

  const [deviceType, setDeviceType] = useState([]);
  const [locationType, setLocationType] = useState([]);
  console.log(locationType, "locationtype");
  //  const [loadingDevice,setLoadingDevice] = useState(false);

  const fetchDevices = async (superId) => {
    if (!superId) return;

    try {
      setDeviceLoading(true);

      const res = await fetch(
        `${API_BASE_URL}api/device/getdevices?SuperId=${superId}`
      );

      const data = await res.json();

      if (data?.status && Array.isArray(data?.ResultData)) {
        setDeviceData(data.ResultData);
      } else {
        setDeviceData([]);
        console.error("Invalid API response:", data);
      }
    } catch (error) {
      console.error("Fetch Devices Error:", error);
      setDeviceData([]);
    } finally {
      setDeviceLoading(false);
    }
  };

  const fetchDeviceTypes = async () => {
    try {
      // setLoadingDevice(true);
      const res = await fetch(`${API_BASE_URL}api/type/getdevicetype`);

      if (!res.ok) throw new Error("Failed to fetch ServiceTypes");
      const data = await res.json();

      if (data.status === true) {
        setDeviceType(
          data?.ResultData?.map((item) => ({
            label: item?.Name,
            value: item?.Id,
          }))
        );
      }
    } catch (error) {
      console.error("Error fetching service types:", error);
    } finally {
      // setLoadingDevice(false);
    }
  };


  const fetchLocationTypes = async (superId) => {
    if (!superId) return;
    try {
      // setLoadingDevice(true);
      const res = await fetch(
        `${API_BASE_URL}api/org/getlocations?SuperId=${superId}`
      );

      if (!res.ok) throw new Error("Failed to fetch ServiceTypes");
      const data = await res.json();

      if (data.status === true) {
        setLocationType(
          data?.ResultData?.map((item) => ({
            label: item?.Name,
            value: item?.Id,
          }))
        );
      }
    } catch (error) {
      console.error("Error fetching service types:", error);
    } finally {
      // setLoadingDevice(false);
    }
  };

  useEffect(() => {
    if (record?.SuperId) {
      fetchDevices(record.SuperId);
      fetchDeviceTypes();
      fetchLocationTypes(record.SuperId);
    }
  }, [record]);
  console.log(deviceForm, "ggggggggggggggg");



  const updateDevice = async () => {
    try {
      const payload = {
        SuperId: record?.SuperId,
        LocationId: Number(deviceForm?.LocationId || 0),
        UserId: userData?.[0]?.UserId,
        Id: deviceForm?.Id,
        SerialNo: deviceForm?.SerialNo,
        MachineId: Number(deviceForm?.MachineId),
        DeviceName: deviceForm?.DeviceName,
        DeviceTypeId: Number(deviceForm?.DeviceTypeId),
        DeviceModel: deviceForm?.DeviceModel,
        ServerPort: Number(deviceForm?.ServerPort),
        IsSpecial: deviceForm?.IsSpecial,
      };

      console.log(payload, "Update Device Payload");

      const res = await fetch(`${API_BASE_URL}api/device/updatedevice`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      const data = await res.json();

      if (data?.status) {
        Swal.fire({
          icon: "success",
          title: "Success",
          text: "Device updated successfully",
          timer: 2000,
          showConfirmButton: false,
        });

        fetchDevices(record?.SuperId);

        resetDeviceForm();
      } else {
        Swal.fire({
          icon: "error",
          title: "Update Failed",
          text: data?.message || "Failed to update device",
        });
      }
    } catch (error) {
      console.error("Update Device Error:", error);

      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something went wrong",
      });
    }
  };


  const addDevice = async () => {
    try {
      const payload = {
        SuperId: record?.SuperId,
        LocationId: Number(deviceForm?.LocationId),
        UserId: userData?.[0]?.UserId,
        Id: 0,
        SerialNo: deviceForm?.SerialNo,
        MachineId: Number(deviceForm?.MachineId),
        DeviceName: deviceForm?.DeviceName,
        DeviceTypeId: Number(deviceForm?.DeviceTypeId),
        DeviceModel: deviceForm?.DeviceModel,
        ServerPort: Number(deviceForm?.ServerPort),
        IsSpecial: deviceForm?.IsSpecial,
      };

      console.log(payload, "Add Device Payload");

      const res = await fetch(`${API_BASE_URL}api/device/adddevice`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      const data = await res.json();

      if (data?.status) {
        Swal.fire({
          icon: "success",
          title: "Success",
          text: "Device added successfully",
          timer: 2000,
          showConfirmButton: false,
        });

        fetchDevices(record?.SuperId);

        resetDeviceForm();
      } else {
        Swal.fire({
          icon: "error",
          title: "Add Failed",
          text: data?.message || "Failed to add device",
        });
      }
    } catch (error) {
      console.error("Add Device Error:", error);

      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something went wrong",
      });
    }
  };

  const deleteDevice = async (DeviceRecord) => {
    try {
      const payload = {
        Id: DeviceRecord?.Id,
        SuperId: record?.SuperId,
        UserId: userData?.[0]?.UserId,
      };

      console.log(payload, "Delete Payload");

      const res = await fetch(`${API_BASE_URL}api/device/deletedevice`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      const data = await res.json();

      if (data?.status) {
        Swal.fire({
          icon: "success",
          title: "Deleted",
          text: "Device deleted successfully",
          timer: 2000,
          showConfirmButton: false,
        });

        fetchDevices(record?.SuperId);
      } else {
        Swal.fire({
          icon: "error",
          title: "Delete Failed",
          text: data?.message || "Failed to delete Device",
        });
      }
    } catch (error) {
      console.error("Delete Device Error:", error);
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something went wrong",
      });
    }
  };






  const handleEditDevice = (device) => {
    setIsEdit(true);

    setDeviceForm({
      Id: device?.Id || 0,
      LocationId: device?.LocationId || "",
      LocationName: device?.LocationName || "",
      SerialNo: device?.SerialNo || "",
      MachineId: device?.MachineId || "",
      DeviceName: device?.DeviceName || "",
      DeviceTypeId: device?.DeviceTypeId || "",
      DeviceModel: device?.DeviceModel || "",
      ServerPort: device?.ServerPort || "",
      IsSpecial: device?.IsSpecial || false,
    });
  };

  const handleCheckbox = (e) => {
    setDeviceForm({
      ...deviceForm,
      IsSpecial: e.target.checked,
    });
  };

  return (
    <div className="modal fade" id="devicemodel">
      <div className="modal-dialog modal-dialog-centered modal-lg">
        <div className="modal-content">
          <div className="modal-header">
            <h4 className="modal-title"> {isEdit ? "Edit" : "Add"} New Device - {" "}
            <span style={{ color: "orange" }}>{record?.OrgName}</span>
            </h4>
            <button
              id="closeAddCompanyModal"
              type="button"
              className="btn-close custom-btn-close p-0"
              data-bs-dismiss="modal"
              aria-label="Close"
              // onClick={() => resetClientForm()}
              onClick={resetDeviceForm}
            >
              <i className="ti ti-x" />
            </button>
          </div>

          <div className="modal-body">
            {/* Form Card */}
            <div className="card border-0 shadow-sm mb-4">
              <div className="card-body">
                <form>
                  <div className="row">
                    <div className="col-md-4">
                      <div className="mb-3 ">
                        <label className="form-label">
                          Serial No
                          <span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          name="SerialNo"
                          value={deviceForm.SerialNo}
                          onChange={(e) =>
                            setDeviceForm({
                              ...deviceForm,
                              SerialNo: e.target.value,
                            })
                          }
                          placeholder="Enter Serial or Mac ID"
                        />
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="mb-3 ">
                        <label className="form-label">
                          Machine Id
                          <span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          name="MachineId"
                          value={deviceForm.MachineId}
                          onChange={(e) =>
                            setDeviceForm({
                              ...deviceForm,
                              MachineId: e.target.value,
                            })
                          }
                          placeholder="Enter Machine or Terminal ID"
                        />
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="mb-3 ">
                        <label className="form-label">
                          Device Name
                          <span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          name="devicename"
                          value={deviceForm.DeviceName}
                          onChange={(e) =>
                            setDeviceForm({
                              ...deviceForm,
                              DeviceName: e.target.value,
                            })
                          }
                          placeholder="Enter Device Name"
                        />
                      </div>
                    </div>

                    <div className="col-md-4">
                      <div className="mb-3 ">
                        <label className="form-label">
                          Location <span className="text-danger">*</span>
                        </label>
                        {/* <input
                          type="text"
                          className="form-control"
                          name="DeviceName"
                          value={deviceForm.DeviceName}
                          onChange={(e) =>
                            setDeviceForm({
                              ...deviceForm,
                              DeviceName: e.target.value,
                            })
                          }
                          placeholder="Enter Location"
                        /> */}
                        <Select
                          className="w-100"
                          style={{ width: 100, height: 38 }}
                          options={locationType}
                          placeholder=" select Location "
                          value={deviceForm.LocationId}
                          onChange={(value) => {
                            setDeviceForm({
                              ...deviceForm,
                              LocationId: value,
                            });
                          }}
                          getPopupContainer={(trigger) => trigger.parentNode}
                          popupClassName=""
                          dropdownStyle={{ zIndex: 9999 }}
                          dropdownRender={(menu) => (
                            <div style={{ zIndex: 9999, position: "relative" }}>
                              {menu}
                            </div>
                          )}
                        />
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="mb-3">
                        <div className="d-flex justify-content-between">
                          <label className="form-label">
                            Device Type <span className="text-danger">*</span>
                          </label>
                        </div>
                        {/* <input
                          type="text"
                          className="form-control"
                          name="DeviceTypeId"
                          value={deviceForm.DeviceTypeId}
                          onChange={(e) =>
                            setDeviceForm({
                              ...deviceForm,
                              DeviceTypeId: e.target.value,
                            })
                          }
                          placeholder="Enter Device Type Id"
                        /> */}
                        <Select
                          className="w-100"
                          style={{ width: 100, height: 38 }}
                          options={deviceType}
                          placeholder=" select device type"
                          value={deviceForm.DeviceTypeId}
                          onChange={(value) => {
                            setDeviceForm({
                              ...deviceForm,
                              DeviceTypeId: value,
                            });
                          }}
                          getPopupContainer={(trigger) => trigger.parentNode}
                          popupClassName=""
                          dropdownStyle={{ zIndex: 9999 }}
                          dropdownRender={(menu) => (
                            <div style={{ zIndex: 9999, position: "relative" }}>
                              {menu}
                            </div>
                          )}
                        />
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="mb-3 ">
                        <label className="form-label">
                          Device Model<span className="text-danger"> *</span>
                        </label>
                        <div className="pass-group">
                          <input
                            type="text"
                            className="form-control"
                            name="DeviceModel"
                            value={deviceForm.DeviceModel}
                            onChange={(e) =>
                              setDeviceForm({
                                ...deviceForm,
                                DeviceModel: e.target.value,
                              })
                            }
                            placeholder="Enter Device Model"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="mb-3 ">
                        <label className="form-label">
                          Server Port:<span className="text-danger"> *</span>
                        </label>
                        <div className="pass-group">
                          <input
                            type="text"
                            className="form-control"
                            name="ServerPort"
                            value={deviceForm.ServerPort}
                            onChange={(e) =>
                              setDeviceForm({
                                ...deviceForm,
                                ServerPort: e.target.value,
                              })
                            }
                            placeholder="Enter Server Port"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-3">
                      <div className="mb-3">
                        <label className="form-label">Is Special Device</label>

                        <div className="form-check mt-2">
                          <input
                            type="checkbox"
                            className="form-check-input"
                            id="specialDevice"
                            checked={deviceForm.IsSpecial}
                            onChange={handleCheckbox}
                          />

                          <label
                            className="form-check-label"
                            htmlFor="specialDevice"
                          >
                            Yes
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Buttons */}
                  <div className="d-flex justify-content-end mt-2">
                    <button
                      type="button"
                      className="btn btn-light me-2"
                      data-bs-dismiss="modal"
                      onClick={resetDeviceForm}
                    >
                      Cancel
                    </button>

                    <button
                      type="button"
                      className="btn btn-primary"
                      onClick={isEdit ? updateDevice : addDevice}
                    >
                      Save
                    </button>
                  </div>
                </form>
              </div>
            </div>

            {/* Table Card */}
            <div className="card border-0 shadow-sm">
              <div className="card-header bg-light d-flex justify-content-between align-items-center">
                <h5 className="mb-0">Devices List</h5>
              </div>

              <div className="card-body p-2">
                <Table
                  columns={columns}
                  dataSource={deviceData}
                  loading={deviceLoading}
                  rowKey={(record) => record.Id}
                  pagination={{ pageSize: 5 }}
                  scroll={{ x: true }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

Devicesmodel.propTypes = {
  record: PropTypes.shape({
    Id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    OrgName: PropTypes.string,
    SuperId: PropTypes.number,
  }),
};

export default Devicesmodel;
